import { useCallback } from 'react'
import { Container } from '~/components/echarts/container'
import { handleExport } from '~/components/echarts/export'
import useRetryablePostJSON from '~/hooks/use_retryable_post_json'

export default function EchartsGrid({
  url,
  params,
  title,
  chartInfoTitle,
  showMaximizeButton = true,
  showExportButton = false,
}) {
  // to-do: handle network failure
  const { data, isLoading } = useRetryablePostJSON({ path: url, params })

  const onExport = useCallback(
    async (format) => {
      return await handleExport(url, params, format)
    },
    [url, params],
  )

  const handleTitle = useCallback(
    (grid) => {
      if (title) {
        return `${title} - ${grid.name}`
      }

      return grid.title
    },
    [title],
  )

  return (
    <>
      {(data.grids || []).map((grid) => (
        <div className='col-sm-6' key={grid.name}>
          <Container
            title={handleTitle(grid)}
            chartInfoTitle={chartInfoTitle}
            data={grid}
            isLoading={isLoading}
            showMaximizeButton={showMaximizeButton}
            showExportButton={showExportButton}
            onExport={onExport}
          />
        </div>
      ))}
    </>
  )
}
